<template>
  <NuxtLayout v-if="hasFetchedMandatoryData">
    <NuxtLoadingIndicator />
    <ConfirmDialog group="appConfirmDialog" />
    <!-- <ConfirmPopup group="appConfirmPopup" /> -->
    <Toast />
    <NuxtPage />
  </NuxtLayout>

  <AppLoader v-else />
</template>

<script lang="ts" setup>
import { AppRoutes } from '~/../genesis/constants/routes'

useHead({
  titleTemplate: (titleChunk: string) => {
    const appName = 'Courtinet'
    return titleChunk ? `${titleChunk} | ${appName}` : appName
  },
})

const route = useRoute()
const user = useCurrentUser()
const hasFetchedMandatoryData = ref(false)
const { setMandatoryInformation } = initializeMandatoryData()

onMounted(async () => {
  await setMandatoryInformation(route.params)
  hasFetchedMandatoryData.value = true

  watch(user, (user, prevUser) => {
    const localeRoute = useLocaleRoute()
    const isProcessOrganizationInvitationPage = localeRoute({ name: 'process-organization-invitation-organizationId-token' })?.name === route.name

    if (isProcessOrganizationInvitationPage) return

    if (prevUser && !user) {
      navigateTo(AppRoutes.Auth.Login)
    }
    else if (user) {
      navigateTo(route.query.redirect as string ?? AppRoutes.SelectOrganization)
    }
  })
})
</script>

<style lang="scss">
// TODO: Update when package will be published
@import "../genesis/assets/styles/app";
</style>
